import * as React from 'react';
import {Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button} from '@mui/material';

interface CreatePlaylistDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (name: string) => void;
    initialName?: string;
    title?: string;
}

export const CreatePlaylistDialog: React.FC<CreatePlaylistDialogProps> = ({
    open,
    onClose,
    onConfirm,
    initialName = '',
    title = 'New Playlist',
}) => {
    const [name, setName] = React.useState(initialName);

    React.useEffect(() => {
        if (open) setName(initialName);
    }, [open, initialName]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const trimmed = name.trim();
        if (trimmed) onConfirm(trimmed);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <form onSubmit={handleSubmit}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        fullWidth
                        variant="standard"
                        placeholder="Playlist name"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        sx={{mt: 1}}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="submit" variant="contained" color="secondary" disabled={!name.trim()}>
                        Save
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};
